/**************************************************
 * Nombre:       Formulario_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {AccountCircleOutlined, FlagOutlined, Google, Title} from "@mui/icons-material";
import {ESTADOSSOPORTE} from "../../Constantes";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {useEffect, useState} from "react";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const Formulario_Soporte = ({...props}) => {
    const {Avisos, nuevoAviso, terminar} = useCargador({logoRedondo: ''})
    const [imagen, setImagen] = useState('')

    useEffect(() => {
        let im = props.props.getValues('img')
        setImagen(im)
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Avisos/>

                <Grid container size={6}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSSOPORTE.map((it) => it.nombre)}

                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>

                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Google} nombre={'Correo'} dato={'correo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Title} nombre={'Asunto'} dato={'asunto'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Descripcion del inconveniente'} dato={'descripcion'} {...props}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{fontWeight: 600}}>Envio de Captura de Pantalla</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center'}}>
                    <Zoom>
                        <img src={imagen} width={'100%'} height={'auto'}/>
                    </Zoom>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Respuesta</Typography>
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Respuesta'} dato={'respuesta'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Soporte